export const HEADINGS = [
  ["code", "Analyte ID"],
  ["name", "Analyte Name"],
  ["level_of_reporting", "Limit of Reporting"],
  ["type", "Type"],
  ["group", "Group"],
  ["status", "Status"],
];

export const searchMap = {
  "Analyte ID": "code",
  "Analyte Name": "name",
  Type: "type",
  Group: "group",
};

export const initialValues = {
  name: "",
  reporting_value: "",
  reporting_unit: "",
  type: "",
  group: "",
  common_product_name: "",
};

export const typesList = [
  {
    value: "Chemical",
    label: "Chemical",
  },
  {
    value: "Micro",
    label: "Micro",
  },
  {
    value: "Water",
    label: "Water",
  },
  {
    value: "Heavy Metal",
    label: "Heavy Metal",
  },
  {
    value: "Miscellaneous",
    label: "Miscellaneous",
  },
];

export const groupsList = [
  {
    value: "Organophosphates",
    label: "Organophosphates",
  },
  {
    value: "Herbicides",
    label: "Herbicides",
  },
  {
    value: "Carbamates",
    label: "Carbamates",
  },
  {
    value: "Others",
    label: "Others",
  },
  {
    value: "Insecticides",
    label: "Insecticides",
  },
  {
    value: "Miscellaneous",
    label: "Miscellaneous",
  },
  {
    value: "Organochlorines",
    label: "Organochlorines",
  },
  {
    value: "Chemistry",
    label: "Chemistry",
  },
  {
    value: "Heavy Metals",
    label: "Heavy Metals",
  },
  {
    value: "Microbiological",
    label: "Microbiological",
  },
  {
    value: "Synthetic Pyrethroids",
    label: "Synthetic Pyrethroids",
  },
  {
    value: "Fungicides",
    label: "Fungicides",
  },
  {
    value: "Acaricides",
    label: "Acaricides",
  },
  {
    value: "Dithiocarbamates",
    label: "Dithiocarbamates",
  },
  {
    value: "Phenols",
    label: "Phenols",
  },
];

const values = [
  "mg/kg",
  "mg/L",
  "/25g",
  "/250g",
  "/100ml",
  "/swab",
  "MPN/g",
  "MPN/swab",
  "μg/kg",
  "CFU/g",
  "CFU/swab",
  "CFU/100ml",
  "CFU/mL",
  "%",
  "/g",
  "CFU/plate",
  "g/100g",
  "%w/w",
  "mEq/kg",
  "% oleic acid on extracted oil",
  "/125g",
  "/100g",
  "/50g",
  "/kg",
  "/mL",
  "kJ",
  "kJ/100g",
  "kJ/100ml",
  "Scoville Units",
  "mg/100g",
  "mg/100mL",
  "mg/g",
  "mg/mL",
  "mg/swab",
  "kcal/g",
  "kcal/100g",
];

export const unitsList = values.map((v) => ({ value: v, label: v }));
